module.exports = {
      id: "ic-drawing-tool-mobile-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-dd90e0.smartcharts.svg#ic-drawing-tool-mobile-usage",
      toString: function () {
        return this.url;
      }
    }